import React from "react";
import styled from "styled-components";
import { Icon, theme } from "uikit";

import { StyledRow } from "../../../../../../../../../../../components/common";

const Label = styled.div`
	font-family: " ";
	font-style: normal;
	font-weight: 600;
	font-size: 18px;
	line-height: 22px;
	letter-spacing: 0.15px;
	color: ${theme.colors.primary};
`;

const Btn = styled.div`
	cursor: pointer;
`;

const Header: React.FC<Header.Props> = ({ title, onClose }) => (
	<StyledRow p="16px 14px" alignItems="center" justify="space-between">
		<Label style={{ color: theme.colors.text_placeholder }}>{title}</Label>
		<Btn onClick={onClose}>
			<Icon id="close" size={12} colors={[theme.colors.secondary]} />
		</Btn>
	</StyledRow>
);

declare namespace Header {
	interface Props {
		title: string;
		onClose: () => void;
	}
}

export default Header;
